export const WORLD_ORDER = [
  "jungle",
  "waterfall",
  "redheat",
  "asteroid",
  "blueplanet",
  "satellite",
  "misty",
  "nebula",
];

export const DIFFICULTY_SCALE = {
  jungle: [5, 7, 9, 11, 14],
  waterfall: [14, 16, 18, 20, 23],
  redheat: [23, 25, 27, 29, 32],
  asteroid: [32, 34, 36, 38, 41],
  blueplanet: [41, 43, 45, 47, 50],
  satellite: [50, 52, 54, 56, 59],
  misty: [59, 61, 63, 65, 68],
  nebula: [68, 71, 74, 77, 80],
  boss: [82, 84, 86, 88, 90, 92, 94, 96, 98, 100],
};

export const WORLD_ROAD_NAMES = {
  jungle: [
    "Canopy Run",
    "Root Tangle",
    "Temple Steps",
    "Vine Verge",
    "Mayhem Heart",
  ],
  waterfall: [
    "First Frost",
    "Glacier Slide",
    "Whirlpool Way",
    "Icefall Drops",
    "Mayhem Falls",
  ],
  redheat: [
    "Ignition Run",
    "Magma Bends",
    "Ashfall Crossing",
    "Molten Spine",
    "Core Breach",
  ],
  asteroid: [
    "Drift Line",
    "Miner's Cut",
    "Debris Corridor",
    "Gravity Scatter",
    "Beltbreaker",
  ],
  blueplanet: [
    "Tide Path",
    "Reef Curve",
    "Mistfall Passage",
    "Crystal Current",
    "Abyss Crown",
  ],
  satellite: [
    "Docking Lane",
    "Panel Run",
    "Signal Relay",
    "Orbital Switch",
    "Transmission Apex",
  ],
  misty: [
    "Fog Entry",
    "Silent Pillars",
    "Veil Crossing",
    "Ghost Track",
    "Phantom Summit",
  ],
  nebula: [
    "Starwake",
    "Ion Drift",
    "Nova Weave",
    "Pulse Corridor",
    "Supernova Crown",
  ],
  boss: [
    "Emberline",
    "Cinder Gate",
    "Slagstorm",
    "Pyroclast",
    "Vulcan Spine",
    "Magma Maw",
    "Obsidian Rift",
    "Hellforge",
    "Caldera Crown",
    "Omega Core",
  ],
};

export function roadDifficulty(worldId, roadIndex) {
  return DIFFICULTY_SCALE[worldId]?.[roadIndex] ?? 1;
}

